export default __webpack_public_path__ + "static/media/calendar-black.8027d85a.svg";